import { CreateResidentInput } from "../../API";
import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import { Link as RouterLink, RouteComponentProps } from "react-router-dom";
import IntakeService from "../Intake/IntakeService";
import AdminService from "../Admin/AdminService";
import { AnyKindOfDictionary, intersection, map } from "lodash";
import { Checkbox } from "@mui/material";
import moment from "moment";
import DetailField from "./DetailField";
import { parse } from "node:path/win32";
const CryptoJS = require("crypto-js");

var validator = require("validator");

const useStyles = makeStyles((theme) => ({
  label: {
    display: "flex",
    [theme.breakpoints.only("xs")]: {
      paddingBottom: "0 !important",
    },
  },
  required: {
    color: "red",
    fontWeight: "bold",
  },
  input: {
    backgroundColor: "#fff",
    [theme.breakpoints.only("xs")]: {
      paddingTop: "0 !important",
    },
  },
  datePicker: {
    marginTop: 0,
  },
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(1000 + (theme.spacing(2) as any) * 2)]: {
      width: 1000,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
}));

interface DetailPageRouteProps {
  page: string;
  intakeId: string;
  sid: string; // staffId
}

interface RouteProps extends RouteComponentProps<DetailPageRouteProps> {}

export default function AddStaff(props: RouteProps) {
  const classes = useStyles();

  const [error, setError] = useState<string>("");

  // const [staff, setstaff] = useState<UpdateResidentInput>();
  const [staff, setStaff] = useState<CreateResidentInput>({
    firstName: "",
    middleName: "",
    lastName: "",
    birthDate: "",
    community: "",
    personType: "",
    personalEmail: "",
    mrn: hashMRN("", 10),
    salesforceID: "",
    locked: Boolean(false),
    firstAdmission: Boolean(false),
    activeAdmission: Boolean(false),
    profile: {
      includeInDirectory: Boolean(false),
      aboutMe: "",
      birthPlace: "",
      favoriteThings: "",
      interests: "",
      profession: "",
    },
    lastLoginDateTime: "",
    activationStartDate: "",
    activationEndDate: "",
    leaveStartDate: "",
    pingAccessStartDate: "",
    gender: "",
    locationID: "",
    customData: {
      mealPlan: {
        type: "",
        title: "",
        description: "",
        balance: undefined,
        total: undefined,
        period: "",
      },
    },
    contactInfo: {
      phones: [
        {
          value: "",
          type: "",
          hidden: false,
          preferred: false,
        },
        {
          value: "",
          type: "",
          preferred: false,
          hidden: false,
        },
        {
          value: "",
          type: "",
          preferred: false,
          hidden: false,
        },
      ],
    },
    preferredName: "",
    preferredFirstName: "",
    status: "",
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipcode: "",
    },
  });

  const [hasAccess, setAccess] = useState<boolean>(false);

  console.log("staffInfo: ", staff);

  const { sid } = props.match.params;

  useEffect(() => {
    console.log("PID----------------------------", sid);

    if (sid !== undefined) {
      buildstaff().then((ci) => {
        if (ci) {
          setStaff(ci);
        } else {
          setError("Error building user info");
        }
      });
      return;
    }
    setStaff(staff);
    // if (pid !== undefined) {
    //     buildExternalstaff().then(ci => {
    //         if (ci) {
    //             setExternalstaff(ci);
    //         } else {
    //             setError('Error building External User info');
    //         }
    //     });
    //     return;
    // }
    // setExternalstaff(null);
  }, [sid]);

  useEffect(() => {
    async function getGroupDetails() {
      const username = localStorage.getItem("userName");
      if (username) {
        const g = await AdminService.getGroupsForUser(username);
        const groupArr = g.map((gx) => gx.GroupName);
        setAccess(intersection(["Admin"], groupArr).length > 0);
      }
    }
    getGroupDetails();
  }, []);

  const communityItems = [
    "All",
    "ACH",
    "APL",
    "APR",
    "BBV",
    "CCI",
    "CCV",
    "DVF",
    "ELM",
    "ETH",
    "FRV",
    "GSV",
    "HSD",
    "LHN",
    "LPH",
    "MGC",
    "OCV",
    "RWV",
    "SBV",
    "SLN",
    "TCK",
    "TGB",
    "WCD",
    "WRC",
  ].map((c: string) => (
    <MenuItem value={c} key={c}>
      {c}
    </MenuItem>
  ));

  const personTypeItems = ["RESIDENT", "STAFF"].map((c: string) => (
    <MenuItem value={c} key={c}>
      {c}
    </MenuItem>
  ));

  const buildstaff = async () => {
    const userQuery = await IntakeService.createResident(staff);
    if (userQuery.data?.createResident) {
      return userQuery.data?.createResident;
    }
    return;
  };

  const handleSave = async () => {
    try {
      if (!sid) {
        console.log(staff);
        IntakeService.createResident(staff as CreateResidentInput);
        handleUpdate();
      }
    } catch (err) {
      console.log("Error creating external User", err);
    }
  };

  const handleUpdate = () => {
    props.history.push(`/`);
  };

  const handleNav = () => {
    props.history.push(`/`);
  };

  // function for updating residents attributes
  const handleInputChange = (field: string, value: string | null | boolean) => {
    let obj: any = {};
    obj[field] = value;

    setStaff({
      ...staff,
      ...obj,
    });
  };

  const [emailError, setEmailError] = useState("");
  const validateEmail = (field: string, value: string | null) => {
    let obj: any = {};
    obj[field] = value;

    if (validator.isEmail(value)) {
      setEmailError("");
    } else {
      setEmailError("Please enter valid email address!");
    }

    setStaff({
      ...staff,
      ...obj,
    });
  };

  // function for updating meal plan balance
  const handleMealUpdates = (field: string, value: string | null | boolean) => {
    let obj: any = {
      customData: {
        mealPlan: {
          description: staff?.customData?.mealPlan?.description,
          balance: staff?.customData?.mealPlan?.balance,
          type: staff?.customData?.mealPlan?.type,
          period: staff?.customData?.mealPlan?.period,
          total: staff?.customData?.mealPlan?.total,
          title: staff?.customData?.mealPlan?.title,
        },
      },
    };
    obj.customData.mealPlan[field] = value;

    setStaff({
      ...staff,
      ...obj,
    });
  };

  // function for updating phone numbers value
  const phoneInfoChange = (
    field: string,
    value: string | boolean | null,
    position: number
  ) => {
    let obj: any = {
      contactInfo: {
        phones: [
          {
            value: staff?.contactInfo?.phones![0]?.value,
            preferred: staff?.contactInfo?.phones![0]?.preferred,
            type: staff?.contactInfo?.phones![0]?.type,
            hidden: staff?.contactInfo?.phones![0]?.hidden,
          },
          {
            value: staff?.contactInfo?.phones![1]?.value,
            preferred: staff?.contactInfo?.phones![1]?.preferred,
            type: staff?.contactInfo?.phones![1]?.type,
            hidden: staff?.contactInfo?.phones![1]?.hidden,
          },
          {
            value: staff?.contactInfo?.phones![2]?.value,
            preferred: staff?.contactInfo?.phones![2]?.preferred,
            type: staff?.contactInfo?.phones![2]?.type,
            hidden: staff?.contactInfo?.phones![2]?.hidden,
          },
        ],
      },
    };
    // let obj : any = {contactInfo: {phones:  [staff?.contactInfo?.phones![0]?.value]}}
    obj.contactInfo.phones[position][field] = value;
    setStaff({
      ...staff,
      ...obj,
    });
  };

  // function for updating profile attributes
  const handleProfileUpdate = (
    field: string,
    value: string | null | boolean
  ) => {
    let obj: any = {
      profile: {
        aboutMe: staff?.profile?.aboutMe,
        birthPlace: staff?.profile?.birthPlace,
        favoriteThings: staff?.profile?.favoriteThings,
        interests: staff?.profile?.interests,
        profession: staff?.profile?.profession,
        includeInDirectory: staff?.profile?.includeInDirectory,
        externalCalendarEnabled: staff?.profile?.externalCalendarEnabled,
      },
    };
    obj.profile[field] = value;

    setStaff({
      ...staff,
      ...obj,
    });
  };

  // This function is for updating address
  const handleUpdateChange = (field: string, value: string) => {
    let obj: any = {
      address: {
        addressLine1: staff?.address?.addressLine1,
        addressLine2: staff?.address?.addressLine2,
        city: staff?.address?.city,
        state: staff?.address?.state,
        zipcode: staff?.address?.zipcode,
      },
    };

    obj.address[field] = value;

    console.log(obj);
    setStaff({
      ...staff,
      ...obj,
    });
  };

  function hashMRN(MRN: any, n: any): string {
    const alphabet_uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const digits = "123456789";
    const ID = MRN;
    // return CryptoJS.MD5(ID).update(ID, 'utf8').digest('hex');
    const hashedID = CryptoJS.MD5(ID).toString();
    const intHashedID = parseInt(hashedID, 16);
    const number = intHashedID.toPrecision();
    var newNumber = "";
    if (n === 0) {
      console.log("HERE1", intHashedID);
    } else {
      for (let i = 0; i < n; i++) {
        var rand = Math.random();
        rand *= 10;
        rand = Math.floor(rand);
        if (rand === 1) {
          rand += 1;
        }
        newNumber += number[rand];
      }
      if (newNumber[0] === "0") {
        var rand = Math.random();
        rand *= 10;
        rand = Math.floor(rand);
        newNumber.replace(newNumber[0], digits[rand]);
      }
    }
    var idLetters = "";
    for (let i = 0; i < 3; i++) {
      var rand2 = Math.random();
      rand2 *= alphabet_uppercase.length;
      rand2 = Math.floor(rand2);
      idLetters += alphabet_uppercase[rand2];
    }
    var intNewNumber = parseInt(newNumber, 10);
    return idLetters + "-" + intNewNumber;
  }
  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"First Name:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff?.firstName || ""}
            // onBlur={event => handleInputBlur('firstName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("firstName", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Middle Name:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff?.middleName || ""}
            // onBlur={event => handleInputBlur('firstName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("middleName", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Gender:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff?.gender || ""}
            // onBlur={event => handleInputBlur('firstName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("gender", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Last Name:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff?.lastName || ""}
            // onBlur={event => handleInputBlur('firstName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("lastName", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">
            {"Person Type"}{" "}
            <sup className={classes.required}>{"\u00A0"}&#42;</sup>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <Select
            fullWidth
            value={staff?.personType || ""}
            onChange={(event) => {
              handleInputChange("personType", event.target.value as string);
            }}
          >
            {personTypeItems}
          </Select>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">
            {"Community"}{" "}
            <sup className={classes.required}>{"\u00A0"}&#42;</sup>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <Select
            fullWidth
            value={staff?.community || ""}
            onChange={(event) => {
              handleInputChange("community", event.target.value as string);
            }}
          >
            {communityItems}
          </Select>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"MRN:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
            fullWidth
            multiline
            minRows={1}
            value={staff.mrn}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Email:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            type="email"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            helperText={emailError}
            value={staff?.personalEmail || ""}
            onChange={(event) =>
              validateEmail("personalEmail", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <DetailField
        type="date"
        labelWidth={4}
        onChange={(value) => {
          handleInputChange("birthDate", value);
        }}
        label="Birth Date:"
        value={
          staff?.birthDate
            ? moment(staff?.birthDate?.replace(/T.*/, "")).format("MM/DD/YYYY")
            : undefined
        }
      />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Locked:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.locked)}
                onChange={(event) =>
                  handleInputChange("locked", event.target.checked)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <DetailField
        type="date"
        labelWidth={4}
        onChange={(value) => {
          handleInputChange("lastLoginDateTime", value);
        }}
        label="Last login Date"
        value={
          staff?.lastLoginDateTime
            ? moment(staff?.lastLoginDateTime?.replace(/T.*/, "")).format(
                "MM/DD/YYYY"
              )
            : undefined
        }
      />

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Meal Type:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff.customData?.mealPlan?.type}
            onChange={(event) => handleMealUpdates("type", event.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Meal Title:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff.customData?.mealPlan?.title}
            onChange={(event) => handleMealUpdates("title", event.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Balance:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff.customData?.mealPlan?.balance}
            onChange={(event) =>
              handleMealUpdates("balance", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Total:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff.customData?.mealPlan?.total}
            onChange={(event) => handleMealUpdates("total", event.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Period:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            minRows={1}
            value={staff.customData?.mealPlan?.period}
            onChange={(event) =>
              handleMealUpdates("period", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Phone:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![0]?.value || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) =>
              phoneInfoChange("value", event.target.value, 0)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Type:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            placeholder="Home/Mobile/Other"
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![0]?.type || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) => phoneInfoChange("type", event.target.value, 0)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Preferred:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![0]?.preferred)}
                onChange={(event) =>
                  phoneInfoChange("preferred", event.target.checked, 0)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Hidden:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![0]?.hidden)}
                onChange={(event) =>
                  phoneInfoChange("hidden", event.target.checked, 0)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Phone:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![1]?.value || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) =>
              phoneInfoChange("value", event.target.value, 1)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Type:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            placeholder="Home/Mobile/Other"
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![1]?.type || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) => phoneInfoChange("type", event.target.value, 1)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Preferred:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![1]?.preferred)}
                onChange={(event) =>
                  phoneInfoChange("preferred", event.target.checked, 1)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Hidden:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![1]?.hidden)}
                onChange={(event) =>
                  phoneInfoChange("hidden", event.target.checked, 1)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Phone:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![2]?.value || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) =>
              phoneInfoChange("value", event.target.value, 2)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Type:"}</Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            placeholder="Home/Mobile/Other"
            fullWidth
            multiline
            minRows={1}
            value={staff?.contactInfo?.phones![2]?.type || ""}
            inputProps={{ maxLength: 10 }}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) => phoneInfoChange("type", event.target.value, 2)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Preferred:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![2]?.preferred)}
                onChange={(event) =>
                  phoneInfoChange("preferred", event.target.checked, 2)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} justifyContent="center">
          <Typography variant="h6" display="flex" justifyContent="center">
            {"Hidden:"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(staff?.contactInfo?.phones![2]?.hidden)}
                onChange={(event) =>
                  phoneInfoChange("hidden", event.target.checked, 2)
                }
              />
            }
            label=""
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Preferred Name:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.preferredName || ""}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("preferredName", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Preferred First Name:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.preferredFirstName || ""}
            // onBlur={event => handleInputBlur('lastName', event.target.value as string)}
            onChange={(event) =>
              handleInputChange("preferredFirstName", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"About Me:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="outlined-multiline-flexible"
            fullWidth
            multiline
            maxRows={4}
            variant="outlined"
            value={staff?.profile?.aboutMe || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleProfileUpdate("aboutMe", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Birth PLace:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="outlined-multiline-flexible"
            fullWidth
            multiline
            maxRows={4}
            variant="outlined"
            value={staff?.profile?.birthPlace || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleProfileUpdate("birthPlace", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Interests:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="outlined-multiline-flexible"
            fullWidth
            multiline
            maxRows={4}
            variant="outlined"
            value={staff?.profile?.interests || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleProfileUpdate("interests", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Profession:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="outlined-multiline-flexible"
            fullWidth
            multiline
            maxRows={4}
            variant="outlined"
            value={staff?.profile?.profession || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleProfileUpdate("profession", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Address:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="filled-read-only-input"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.address?.addressLine1 || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleUpdateChange("addressLine1", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        ></Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="filled-read-only-input"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.address?.addressLine2 || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) =>
              handleUpdateChange("addressLine2", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"City:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="filled-read-only-input"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.address?.city || ""}
            // onBlur={event => handleInputBlur('city', event.target.value as string)}
            onChange={(event) => handleUpdateChange("city", event.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"State:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="filled-read-only-input"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.address?.state || ""}
            // onBlur={event => handleInputBlur('state', event.target.value as string)}
            onChange={(event) =>
              handleUpdateChange("state", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Zip Code:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="filled-read-only-input"
            fullWidth
            multiline
            minRows={1}
            variant="outlined"
            value={staff?.address?.zipcode || ""}
            // onBlur={event => handleInputBlur('zipcode', event.target.value as string)}
            onChange={(event) =>
              handleUpdateChange("zipcode", event.target.value)
            }
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          justifyContent="center"
          className={classes.label}
        >
          <Typography variant="h6">{"Note:"}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
        >
          <TextField
            id="outlined-multiline-flexible"
            fullWidth
            multiline
            maxRows={4}
            variant="outlined"
            value={staff?.note || ""}
            // onBlur={event => handleInputBlur('address', event.target.value as string)}
            onChange={(event) => handleInputChange("note", event.target.value)}
          />
        </Grid>
      </Grid>

      {/* 
            Button for save and cancel  
            */}
      <div style={{ float: "right", paddingTop: "12px" }}>
        <Button onClick={handleNav} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="success" variant="contained">
          Save
        </Button>
      </div>
    </React.Fragment>
  );
}
